import "./App.css";
import React from "react";
import AppShell from "./app/AppShell";


function App() {
  return <AppShell />;
}


export default App;
